import { render, staticRenderFns } from "./SchoolContractModal.vue?vue&type=template&id=1e98f52d&scoped=true&"
import script from "./SchoolContractModal.vue?vue&type=script&lang=js&"
export * from "./SchoolContractModal.vue?vue&type=script&lang=js&"
import style0 from "./SchoolContractModal.vue?vue&type=style&index=0&id=1e98f52d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e98f52d",
  null
  
)

export default component.exports